import { useDraggable } from '@dnd-kit/core'

export const useCueDragHandle = (cueId: string) => {
  const { listeners, setActivatorNodeRef } = useDraggable({
    id: cueId,
  })

  return { listeners, setActivatorNodeRef }
}
